import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { makeStyles } from 'tss-react/mui'

import HelpDropDown from '@src/components/shared/TopNav/HelpDropDown'

const useStyles = makeStyles()((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  divider: {
    margin: theme.spacing(4, 0),
  },
}))

const AuthCardHeader: React.FC<
  React.PropsWithChildren<{
    header: React.ReactNode
    hideHelp?: boolean
  }>
> = (props) => {
  const { classes } = useStyles()
  return (
    <>
      <Box className={classes.header}>
        <Typography variant={'h5'}>{props.header}</Typography>
        {props.hideHelp ? null : <HelpDropDown />}
      </Box>
      <Divider className={classes.divider} />
    </>
  )
}

export default AuthCardHeader
